import { ContentSlotType } from '../../models/Content';

export const transformContentSlot = (contentSlot: ContentSlotType) => {
    return {
        identifier: contentSlot.fields.identifier,
        contents: contentSlot.fields.contents,
    };
};
